import { BookOpenCheck, Boxes, ClipboardCheck, MapPinCheck, Package, Plane } from "lucide-react";
import { useInView } from "./Sections";

const STEPS = [
  { step: "01", name: "BOOK", desc: "Enter pickup & package details online in 60 seconds", icon: BookOpenCheck },
  { step: "02", name: "PICKUP", desc: "Courier executive collects the parcel from your doorstep", icon: Package },
  { step: "03", name: "PROCESS", desc: "Weight, measurement & security scan at our hub", icon: Boxes },
  { step: "04", name: "FLY", desc: "Loaded onto partner airline or surface linehaul", icon: Plane },
  { step: "05", name: "CUSTOMS", desc: "Fast-track clearance at the destination port", icon: ClipboardCheck },
  { step: "06", name: "DELIVER", desc: "Last-mile doorstep delivery with digital proof", icon: MapPinCheck },
];

export default function JourneyTimeline() {
  const [ref, inView] = useInView();
  return (
    <section className="relative overflow-hidden bg-white py-20 sm:py-28" data-testid="journey-timeline" ref={ref}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-saffron">The Journey</p>
        <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-navy sm:text-5xl">
          HOW INDIAFAST MOVES<br /><span className="text-saffron">YOUR SHIPMENT</span>
        </h2>

        <div className={`mt-16 transition-all duration-700 ${inView ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <div className="relative hidden lg:block">
            <div className="absolute left-0 right-0 top-7 h-0.5 bg-slate-200" />
            <div className="absolute left-0 top-7 h-0.5 bg-gradient-to-r from-saffron via-saffron to-emerald-500 journey-line" />
            <div className="journey-dot absolute top-[1.15rem] z-10 grid h-9 w-9 place-items-center rounded-full bg-navy text-saffron shadow-lg shadow-navy/40">
              <Package className="h-4 w-4" />
            </div>
            <div className="grid grid-cols-6 gap-4">
              {STEPS.map((s, i) => (
                <div key={s.step} className="relative pt-16 text-center" data-testid={`journey-step-${i}`}>
                  <span className={`absolute left-1/2 top-4 z-10 grid h-7 w-7 -translate-x-1/2 place-items-center rounded-full border-2 bg-white text-[10px] font-black ${inView ? "border-saffron text-saffron" : "border-slate-300 text-slate-400"} transition-colors`}
                        style={{ transitionDelay: `${i * 500}ms` }}>
                    {i + 1}
                  </span>
                  <span className="mx-auto grid h-12 w-12 place-items-center rounded-2xl bg-navy text-white">
                    <s.icon className="h-5 w-5" />
                  </span>
                  <p className="mt-4 font-heading text-sm font-extrabold tracking-wide text-navy">{s.step} · {s.name}</p>
                  <p className="mx-auto mt-2 max-w-[11rem] text-xs leading-relaxed text-slate-500">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:hidden">
            <div className="relative ml-5 border-l-2 border-dashed border-saffron/40 pl-8">
              {STEPS.map((s, i) => (
                <div key={s.step} className="relative pb-8 last:pb-0" data-testid={`journey-step-m-${i}`}>
                  <span className="absolute -left-[2.65rem] grid h-10 w-10 place-items-center rounded-2xl bg-navy text-white shadow-lg">
                    <s.icon className="h-4 w-4" />
                  </span>
                  <p className="font-heading text-sm font-extrabold tracking-wide text-navy">{s.step} · {s.name}</p>
                  <p className="mt-1 text-xs leading-relaxed text-slate-500">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
